// node modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import PulseLoader from 'react-spinners/PulseLoader';
import NoSsr from '@material-ui/core/NoSsr';

// app: components
import Button from 'components/Button';

class SpinnerButton extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    onClick: PropTypes.func,
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    type: PropTypes.oneOf(['button', 'submit']),
    size: PropTypes.oneOf(['default', 'medium', 'large', 'extra-large']),
  };

  static defaultProps = {
    className: '',
    disabled: false,
    loading: false,
    onClick: () => {},
    type: 'button',
    size: 'extra-large',
  };

  render() {
    const { className, disabled, loading, onClick, text, type, size, ...rest } = this.props;

    const defaults = {
      className: classNames(className, 'button--block'),
      size,
      themeName: loading || disabled ? 'dusty' : 'energized',
    };

    const attributes =
      loading || disabled
        ? defaults
        : {
            ...defaults,
            onClick,
          };

    return (
      <NoSsr
        fallback={
          <Button {...attributes} {...rest} disabled>
            {text}
          </Button>
        }
      >
        <Button {...attributes} {...rest} disabled={disabled}>
          <PulseLoader loading={loading} color="#fff" sizeUnit="px" size={10} />
          {loading ? null : text}
          {type === 'submit' && <input type="submit" disabled={disabled} hidden />}
        </Button>
      </NoSsr>
    );
  }
}

export default SpinnerButton;
